import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import {withStyles} from '@material-ui/core/styles';
import Toolbar from "../../components/Toolbar/Toolbar";
import {goBack} from "../../fn/navigation";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Card from "@material-ui/core/Card/Card";
import PersonDetails from "../../components/Persons/PersonsDetails";
import Paper from "@material-ui/core/Paper/Paper";
import { faFileSignature, faFileInvoice } from "@fortawesome/free-solid-svg-icons/index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios/index";

const icn = (iconType, classes) => {
    return <FontAwesomeIcon icon={iconType} className={classes.tabBarButtonIcon}/>;
}

const PersonsShow = ({person, personType, backLink, classes}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={person.first_name ? person.first_name + ' ' + person.last_name : person.last_name}
            items={[
                {
                    icon: 'arrow_back',
                    text: i18n.get('contacts.back'),
                    href: backLink,
                    onClick: (event) => {
                        event.preventDefault();
                        goBack(backLink);
                    },
                    color: 'secondary',
                },
                {
                    fontawesome: icn(faFileSignature, classes),
                    text: i18n.get('accounts.new_account'),
                    href: `/accounts/${person.id}-${person.last_name}/create`
                },
                {
                    fontawesome: icn(faFileSignature, classes),
                    text: i18n.get('contracts.new_contract'),
                    href: `/contracts/${person.id}-${person.last_name}/create`
                },
                {
                    fontawesome: icn(faFileInvoice, classes),
                    text: i18n.get('persons.create_invoice'),
                    onClick: () => {
                        // location.reload();

                        axios.get(`/invoice/person/create/${person.id}`).then(() => {
                            location.reload();
                        });
                    }
                },
                {
                    icon: 'edit',
                    text: i18n.get('contacts.edit'),
                    href: `/persons/${personType}/${person.id}/edit`,
                }
            ]}
        />

                <PersonDetails person={person} personType={personType}/>
    </Layout>
);

const styles = theme => ({
    tabBar: {
        marginBottom: theme.spacing.unit * 3,
    },
    tabBarTitle: {
        flexGrow: 1,
    },
    tabBarButton: {
        marginLeft: theme.spacing.unit * 2,
    },
    tabBarButtonIcon: {
        marginRight: theme.spacing.unit,
    },
});

export default withStyles(styles)(PersonsShow);



// WEBPACK FOOTER //
// ./resources/assets/js/pages/persons/Show.jsx